import React, {ReactElement, Component, useEffect, useContext, useState, Dispatch, SetStateAction} from 'react';
import {FormattedMessage, injectIntl} from 'react-intl';
import "../less/service.less";
import {
    http_get,
    router_link,
    format_time,
    http_post,
    http_delete,
    alert,
    http_put,
    loading_alert_before,
    loading_alert_after,
    user_selected_content_sidebar,
} from '../common-file/service';

// 组建
import ArrowBack from '../component/arrow-back';
import BodyTitleCard from '../component/body-title-card';
import TableList from '../component/table';
import ContentSidebar from '../component/content-sidebar';
import Modals from '../component/modal';

// 变量
import {ModalVisibleContext} from '../contexts/modal-visible';
import {ModalDataContext} from '../contexts/modal-data';
import {SearchValueContext} from '../contexts/search-value';
import {ContentSidebarSelectedContext} from '../contexts/content-sidebar-selected';
import {ContentSidebarToggleContext} from '../contexts/content-sidebar-toggle';
import {ModalLoadingContext} from "../contexts/modal-loading";

import {modalType, itemType, modalDataType} from '../common-file/interfaceType';

const columns_2 = ['secret_name', 'cluster', 'workspace', 'namespace', 'create_time'];

const columns_3 = ['status', 'dccs_name', 'description', 'create_time'];

const content_sidebar_list: any =[
    {
        key: 'secret',
        name: 'secrets'
    },
    {
        key: 'DCCS',
        name: 'service_key'
    }
];

const service_data_create: any = {
    MongoDB: true,
    PostgreSQL: true,
    Influxdb: true,
    InfluxDB: true
};

const service_rmq: string | null = 'RabbitMQ';

const CreateSecret: React.FC = (props: any): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> => {

    const {intl} = props,
        [modal_visible, set_modal_visible]: [modalType, Dispatch<SetStateAction<modalType>>] = useContext(ModalVisibleContext),
        [modal_data, set_modal_data]: [modalDataType, Dispatch<SetStateAction<modalDataType>>] = useContext(ModalDataContext),
        [table_1, set_table_1] = useState({} as unknown as itemType),
        [table, set_table]: [any, Dispatch<SetStateAction<any>>] = useState({secret: [], dccs: []}),
        [reload_secret, set_reload_secret]: [boolean, Dispatch<SetStateAction<any>>] = useState(false),
        session_item: string | null = sessionStorage.getItem('instance_list_item_selected'),
        [filter_table, set_filter_table]: [any, Dispatch<SetStateAction<any>>] = useState({secret: [], dccs: []}),
        search_value: any = useContext(SearchValueContext)[0],
        [content_sidebar_selected, set_content_sidebar_selected]: [string, Dispatch<SetStateAction<string>>]= useContext(ContentSidebarSelectedContext),
        content_sidebar_toggle: boolean= useContext(ContentSidebarToggleContext)[0],
        set_modal_loading: Dispatch<SetStateAction<boolean>> = useContext(ModalLoadingContext)[1];

    useEffect(() => {
        if (Object.keys(table_1).length <= 0) {
            if (session_item) {
                let item = JSON.parse(session_item) as unknown as itemType;
                set_table_1(item);
            } else {
                router_link(props, '/instance-list')
            }
        }
        // eslint-disable-next-line
    }, [table_1]);

    useEffect(() => {
        if ((table.secret && table.secret.length <= 0 && Object.keys(table_1).length > 0) || reload_secret) {
            reload_secret && set_reload_secret(false);
            loading_alert_before();
            (async () => {
                const {instanceId, service} = table_1,
                    secret_list: any = await http_get(`/serviceHub/v2/serviceInstances/${instanceId}/bindings?enableSecret=true`, props),
                    dccs_list: any = await http_get(`/serviceHub/v2/serviceCredentials?serviceName=${service}&serviceInstanceId=${instanceId}`, props);
                let secret: any = [], dccs: any = [];
                if (secret_list?.data?.bindings) {
                    // eslint-disable-next-line
                    secret_list.data.bindings.map((item: any, key: number) => {
                        secret.push({
                            key: key,
                            name: item.secretName,
                            cluster: item.clusterName,
                            workspace: item.workspaceName,
                            namespace: item.namespaceName,
                            createTime: format_time(item.createdAt),
                            parameters: item.parameters,
                            dccsStatus: item.dccsStatus,
                            datacenterCode: item.datacenterCode,
                            serviceBindingId: item.serviceBindingId,
                            serviceInstanceId: item.serviceInstanceId,
                            serviceCategory: item.serviceCategory,
                            subscriptionId: item.subscriptionId,
                            userId: item.userId,
                            credentials: item.credentials,
                            instanceName: item.serviceInstanceName
                        })
                    })
                } else {
                    secret = null;
                }
                if (dccs_list?.data?.dccsList) {
                    // eslint-disable-next-line
                    dccs_list.data.dccsList.map((item: any, key: number) => {
                        item.dccsStatus !== 'delete' && dccs.push({
                            key: key,
                            name: item.dccsKey,
                            createTime: format_time(item.createdAt),
                            parameters: item.parameters,
                            dccsKey: item.dccsKey,
                            dccsStatus: item.dccsStatus,
                            // datacenterCode: item.datacenterCode,
                            serviceBindingId: item.serviceBindingId,
                            serviceInstanceId: item.serviceInstanceId,
                            // serviceCategory: item.serviceCategory,
                            subscriptionId: item.subscription_id,
                            // userId: item.userId,
                            credentials: item.credentials,
                            status: item.dccsStatus,
                            description: item.dccsKeyDescription,
                            enable: item.dccsStatus,
                            instanceName: item.serviceInstanceName
                        })
                    })
                } else {
                    dccs = null;
                }
                set_table({secret: secret, dccs: dccs});
                loading_alert_after();
            })()
        }
        // eslint-disable-next-line
    }, [table, reload_secret, table_1]);

    useEffect(() => {
        if (search_value.secretManagement) {
            const secret: [] = table.secret ? table.secret.filter((item: any) => item.name.toLocaleLowerCase().indexOf(search_value.secretManagement.toLocaleLowerCase()) > -1) : [],
                dccs: [] = table.dccs ? table.dccs.filter((item: any) => `${item.name},${item.description || ''}`.toLocaleLowerCase().indexOf(search_value.secretManagement.toLocaleLowerCase()) > -1) : [];
            set_filter_table({
                secret: secret,
                dccs: dccs
            })
        } else {
            set_filter_table({
                secret: table.secret,
                dccs: table.dccs
            });
        }
    }, [search_value, table]);

    useEffect(() => {
        if (modal_visible.toggle) {
            const secret_list_item_selected: any = JSON.parse(sessionStorage.getItem('secret_list_item_selected') || '{}'),
                {service, plan} = JSON.parse(session_item || '{}');
            let title: string = '', content: JSX.Element = <div/>, type: string = '', json: any = [],
                item: object = {};
            switch (modal_visible.type) {
                case 'create':
                    if (service === service_rmq) {
                        item = {
                            rmq: true
                        }
                    }
                    if (content_sidebar_selected !== 'DCCS') {
                        title = 'create_secret';
                        item = {
                            ...item,
                            name: true,
                            cluster: true,
                            workspace: true,
                            namespace: true,
                            parameters: true
                        }
                    } else {
                        title = 'create_DCCS';
                        item = {
                            ...item,
                            description: true,
                            parameters: true
                        };
                    }
                    if(service_data_create[service] && plan.toLowerCase() !== 'shared'){
                        item = {
                            ...item,
                            db: true
                        }
                    }
                    if(service === service_rmq && plan.toLowerCase() !== 'standard'){
                        item = {
                            ...item,
                            IoTHub: true,
                            rmqRole: true
                        }
                    }
                    type = 'create';
                    break;
                case 'delete':
                    title = 'confirm';
                    content = (
                        <div>
                            <FormattedMessage
                                id={'delete_secret'}
                                values={{
                                    secretName: secret_list_item_selected.name
                                }}
                            />
                        </div>
                    );
                    type = 'delete';
                    break;
                case 'recreate':
                    title = 'confirm';
                    content = (
                        <div>
                            <FormattedMessage
                                id={'recreate_secret'}
                                values={{secretName: secret_list_item_selected.name}}
                            />
                            <br/>
                            <FormattedMessage id={'sure_to_recreate'}/>
                        </div>
                    );
                    type = 'recreate';
                    break;
                case 'view':
                    title = 'view';
                    json = [
                        {
                            title: 'credentials',
                            data:secret_list_item_selected.credentials
                        },
                        {
                            title: 'parameters',
                            data: secret_list_item_selected.parameters
                        }
                    ];
                    type = 'view';
                    break;
                case 'edit':
                    title = 'edit_DCCS';
                    const {description} = secret_list_item_selected;
                    // if(service_name === service_rmq){
                    //     item={
                    //         description: true,
                    //         rmq: true,
                    //         itemValue:{
                    //             description: description,
                    //             role: parameters.rmqRole,
                    //             topic_read_path: parameters.rmqTopicRead,
                    //             topic_write_path: parameters.rmqTopicWrite
                    //         }
                    //     }
                    // }else {
                    item = {
                        description: true,
                        itemValue: {
                            description: description
                        }
                    };
                    // }
                    type = 'edit';
                    break;
                case 'enable':
                    title = 'confirm';
                    content = (
                        <div>
                            <FormattedMessage id={'sure_to_enable'}/>
                        </div>
                    );
                    type = 'enable';
                    break;
                case 'disable':
                    title = 'confirm';
                    content = (
                        <div>
                            <FormattedMessage id={'sure_to_disable'}/>
                        </div>
                    );
                    type = 'disable';
                    break;
                default:
                    break;
            }
            title && set_modal_data({
                title: title,
                type: type,
                confirmContent: content,
                jsonView: json,
                item: item,
                datasource: content_sidebar_selected === 'DCCS'? table.dccs: table.secret
            })
        } else {
            set_modal_data({})
        }
        // eslint-disable-next-line
    }, [modal_visible, set_modal_data]);

    useEffect(() => {
        if (modal_data.formValue) {
            const select_item = JSON.parse(sessionStorage.getItem('secret_list_item_selected') || '{}') as unknown as itemType;
            const dis_en_able_fun = ()=>{
                (async () => {
                    loading_alert_before();
                    const {dccsKey} = select_item;
                    let edit_rmq: any = await http_put(`/dccs/v1/serviceCredentials/${dccsKey}/operations/${modal_data.type}`, null, props);
                    loading_alert_after();
                    if (edit_rmq) {
                        alert('success', intl.formatMessage({id: modal_data.type === "disable" ? "disable_1" :  modal_data.type}), intl.formatMessage({id: modal_data.type === 'enable' ? 'enable_success' : 'disable_success'}));
                        set_reload_secret(true);
                    }
                })()
            };
            switch (modal_data.type) {
                case 'create':
                    const service_selected = JSON.parse(session_item || '{}') as unknown as itemType,
                        service_name: string | undefined = service_selected.service,
                        {instanceId, instanceName, subscriptionId, serviceCategory, service, datacenterCode, plan} = table_1,
                        {parameters, rmqRole, rmqTopicRead, rmqTopicWrite, db, IoTHub} = modal_data.formValue;
                    let rmq_parameters: any = parameters;
                    if (service_name === service_rmq) {
                        rmq_parameters = {
                            ...parameters,
                            rmqRole: rmqRole || '',
                            rmqTopicRead: rmqTopicRead || '',
                            rmqTopicWrite: rmqTopicWrite || ''
                        }
                    }
                    db && (rmq_parameters.databaseName = db);
                    IoTHub && (rmq_parameters.vhostName = IoTHub);
                    if (content_sidebar_selected !== 'DCCS') {
                        (async () => {
                            loading_alert_before();
                            const {name, cluster, workspace, namespace} = modal_data.formValue,
                                workspace_json = JSON.parse(workspace || '{id:"",name:""}');
                            let form_data: any = {
                                serviceInstanceId: instanceId,
                                serviceInstanceName: instanceName,
                                serviceCategory: serviceCategory,
                                subscriptionId: subscriptionId,
                                serviceName: service,
                                datacenterCode: datacenterCode,
                                planName: plan,
                                secretName: name,
                                enableSecret: true,
                                clusterName: cluster === '-1' ? '' : cluster,
                                workspaceId: workspace === '-1' ? '' : workspace_json.id,
                                workspaceName: workspace === '-1' ? '' : workspace_json.name,
                                namespaceName: namespace === '-1' ? '' : namespace,
                                parameters: rmq_parameters
                            };
                            const add_secret: any = await http_post(`/serviceHub/v2/serviceInstances/${instanceId}/bindings`, form_data, props);
                            loading_alert_after();
                            if (add_secret) {
                                set_modal_visible({toggle: false});
                                alert('success', intl.formatMessage({id: 'create'}), intl.formatMessage({id: 'create_success_sp'}));
                                set_reload_secret(true);
                            }else {
                                set_modal_loading(false)
                            }
                        })()
                    } else {
                        (async () => {
                            loading_alert_before();
                            const {description} = modal_data.formValue;
                            let form_data: any = {
                                serviceInstanceId: instanceId,
                                // subscriptionId: subscriptionId,
                                serviceKeyDescription: description,
                                serviceParameter: rmq_parameters
                            };
                            const create_dccs = await http_post('/dccs/v1/serviceCredentials', form_data, props);
                            loading_alert_after();
                            if (create_dccs) {
                                set_modal_visible({toggle: false});
                                alert('success', intl.formatMessage({id: 'create'}), intl.formatMessage({id: 'create_success_sp'}));
                                set_reload_secret(true);
                            }else {
                                set_modal_loading(false)
                            }
                        })()
                    }
                    break;
                case 'delete':
                    (async () => {
                        loading_alert_before();
                        const {serviceInstanceId, serviceBindingId, dccsKey} = select_item;
                        let delete_secret: any = null, delete_dccs: any = null;
                        if (content_sidebar_selected !== 'DCCS') {
                            delete_secret = await http_delete(`/serviceHub/v2/serviceInstances/${serviceInstanceId}/bindings/${serviceBindingId}`, null, props);
                        } else {
                            delete_dccs = await http_delete(`/dccs/v1/serviceCredentials/${dccsKey}`, null, props)
                        }
                        loading_alert_after();
                        if (delete_secret || delete_dccs) {
                            alert('success', intl.formatMessage({id: 'delete'}), intl.formatMessage({id: 'delete_success'}));
                            set_reload_secret(true);
                        }
                    })();
                    break;
                case 'recreate':
                    (async () => {
                        loading_alert_before();
                        const {serviceInstanceId, serviceBindingId} = select_item,
                            delete_res: any = await http_put(`/serviceHub/v2/serviceInstances/${serviceInstanceId}/bindings/${serviceBindingId}`, null, props);
                        loading_alert_after();
                        if (delete_res) {
                            alert('success', intl.formatMessage({id: 'recreate'}), intl.formatMessage({id: 'recreate_success'}));
                            set_reload_secret(true);
                        }
                    })();
                    break;
                case 'edit':
                    (async () => {
                        loading_alert_before();
                        const {dccsKey} = select_item,
                            {description} = modal_data.formValue,
                            edit_rmq = await http_put(`/serviceHub/v2/serviceCredentials/${dccsKey}`, {
                                operation: 'none',
                                description: description
                            }, props);
                        loading_alert_after();
                        if (edit_rmq) {
                            alert('success', intl.formatMessage({id: 'edit'}), intl.formatMessage({id: 'edit_success'}));
                            set_reload_secret(true);
                        }
                    })();
                    break;
                case 'disable': dis_en_able_fun(); break;
                case 'enable': dis_en_able_fun(); break;
                default: break;
            }
        }
        // eslint-disable-next-line
    }, [modal_data]);

    return (
        <div className="has-sidebar px-20 mt-20">
            <ContentSidebar
                menuData={{
                    selected: user_selected_content_sidebar(content_sidebar_list, set_content_sidebar_selected),
                    list: content_sidebar_list
                }}
            />
            <div className={`content-body ${content_sidebar_toggle && 'sidebar-show'}`}>
                <ArrowBack
                    backTo={'instance_list'}
                    sidebarToggle={true}
                />
                <BodyTitleCard
                    card_title={{
                        title: table_1.instanceName,
                        name: 'create_secret_title',
                        subscription: 'create_secret_subscription',
                        info:[
                            {
                                key: 'instance_name',
                                value: table_1.instanceName
                            },
                            {
                                key: 'service_name',
                                value: table_1.service
                            },
                            {
                                key: 'plan_sp',
                                value: table_1.plan
                            }
                        ]
                    } as any}
                    formList={{
                        input: [{
                            key: 'input',
                            xs: 24,
                            sm: 24,
                            md: 24,
                            lg: 24,
                            xxl: 24
                        }],
                        add: true,
                        select: {}
                    } as any}
                    searchPlaceholder={intl.formatMessage({id: content_sidebar_selected === 'secret'? 'secret_name': 'dccs_name'})}
                />
                <div className={'mt-20 no_pointer'}>
                    {content_sidebar_selected === 'DCCS' &&
                    <TableList
                    datasource={filter_table.dccs || []}
                    columns={columns_3 as any}
                    action={{edit: true, view: true, enable: true, delete: true} as any}
                    />}
                    {content_sidebar_selected === 'secret' &&
                    <TableList
                        datasource={filter_table.secret || []}
                        columns={columns_2 as any}
                        action={{view: true, recreate: true, delete: true} as any}
                    />}
                    </div>
            </div>
            <Modals/>
        </div>
    )

};

export default injectIntl(CreateSecret);
